<template>
  <div class="page-journal">
    <n-card :loading="$var('load')">
      <n-tabs :data="tabs" state />
      <n-tabs-content v-if="project && journal" class="content">
        <template #chapter1>
          <chapter1 :project="project" :journal="journal" :editable="editable" />
        </template>
        <template #chapter2>
          <chapter2 :project="project" :journal="journal" />
        </template>
        <template #chapter3>
          <chapter3 :project="project" :journal="journal" />
        </template>
      </n-tabs-content>
    </n-card>
  </div>
</template>

<script>
import Chapter1 from './Chapter1'
import Chapter2 from './Chapter2'
import Chapter3 from './Chapter3'

export default {
  name: 'PageJournal',
  components: { Chapter1, Chapter2, Chapter3, },
  props: {
    project: { type: Object, default: null, },
    journal: { type: Object, default: null, },
    loading: { type: Boolean, default: false, },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
    tabs: [
      { name: 'chapter1', title: 'Общие сведения', },
      { name: 'chapter2', title: 'Список звеньевых (монтажников), занятых установкой болтов', },
      { name: 'chapter3', title: 'Записи', },
    ],
  }),
}
</script>

<style lang="scss" scoped>
  .page-journal {

  }
</style>
